import script from "./AppLayoutDefault.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayoutDefault.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayoutDefault.vue?vue&type=style&index=0&id=b6896292&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6896292"]])

export default __exports__